import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type PersonaDimension = { name: string, value: string }

export enum PersonaStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED'
}

export type Persona = {
    id: string,
    givenName?: string,
    familyName?: string,
    email?: string,
    note?: string,
    status?: string,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    managedByUsername?: string
    managedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IPersonaTableColumn extends ITableColumn {
    render?: (item: Persona) => ReactNode;
}

export type ListPersonas = {
    listPersonas: { items: Persona[], nextToken: string | null }
}

export type GetPersona = {
    getPersona: Persona
}

export type CreatePersona = {
    createPersona: Persona
}

export type UpdatePersona = {
    updatePersona: Persona
}

export type DeletePersona = {
    deletePersona: string
}
